const initialState = {
	patients: [],
	searchPhrase: '',
	loading: false,
	selected: null,
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'CHANGE_PHRASE':
			return {
				...state,
				searchPhrase: action.payload,
				selected: null,
			};

		case 'QUERY_PATIENTS':
			return {
				...state,
				loading: true,
			};

		case 'RECEIVE_PATIENTS':
			return {
				...state,
				patients: action.payload,
				loading: false,
			};

		case 'CLEAR_PATIENTS':
			return {
				...state,
				patients: [],
				loading: false,
			};

		case 'SELECT_PATIENT':
			return {
				...state,
				selected: action.payload,
			};

		default:
			return state;
	}
};

export default reducer;



// WEBPACK FOOTER //
// ./js/reducers/patients.js